import {all} from 'redux-saga/effects';
import DoctorDashboardSagas from "../doctor-dashboard/store/doctor-dashboard.sagas";

export default function* rootSaga() {
    yield all([
        DoctorDashboardSagas(),
    ]);
}